import React from "react";

import { GenericSimpleToggleButton } from 'com-gyf-webcore-userinterfacecomponents';

const Permisos = (props) => {
    return (
        <li className="inlineListItem">
            <div className="btn-group top-separator-xxxs">
                <GenericSimpleToggleButton text={props.description} buttonType="btn btn-tag btn-tag-secondary no-margin-bottom no-margin-left not-clickable"
                    key={props.key + props.description} />
            </div>
        </li>
    );
}

export default Permisos;